/**
 * Keyword domain classification for weekly review diversification.
 * Mirrors backend KEYWORD_DOMAIN_PATTERNS in keywords/constants.py.
 */

export type KeywordDomain = 'ai_software' | 'gis_spatial' | 'environmental' | 'engineering' | 'general';

const DOMAIN_PATTERNS: Array<[KeywordDomain, string[]]> = [
  [
    'ai_software',
    [
      'machine learning',
      'deep learning',
      'artificial intelligence',
      'generative ai',
      'llm',
      'nlp',
      'computer vision',
      'mlops',
      'predictive analytics',
      'software',
      'saas',
      'platform',
      'automation',
      'workflow automation',
      'intelligent automation',
      'process automation',
      'devops',
      'microservice',
      'application development',
      'software development',
      'web application',
      'enterprise software',
      'custom software',
      'decision support',
      'api integration',
      'data platform',
      'cloud',
      'digital transformation',
      'analytics',
      'govtech',
      'ict',
      'technology solution',
    ],
  ],
  [
    'gis_spatial',
    [
      'gis',
      'geospatial',
      'spatial',
      'mapping',
      'geodatabase',
      'survey',
      'surveying',
      'remote sensing',
      'lidar',
      'photogrammetry',
      'cadastral',
      'cartography',
      'topographic',
      'digitization',
      'georeferencing',
      'web gis',
      'uav',
      'dgps',
      'land bank',
    ],
  ],
  [
    'environmental',
    [
      'environmental',
      'remediation',
      'contaminated',
      'ecological',
      'habitat',
      'eia',
      'esia',
      'climate',
      'biodiversity',
      'water quality',
      'air quality',
      'waste',
      'reclamation',
      'restoration',
      'monitoring',
    ],
  ],
  [
    'engineering',
    [
      'engineering',
      'infrastructure',
      'construction',
      'design',
      'feasibility',
      'technical',
      'inspection',
      'commissioning',
      'installation',
    ],
  ],
];

export function classifyKeywordDomain(keyword: string): KeywordDomain {
  const lower = (keyword || '').toLowerCase();
  for (const [domain, patterns] of DOMAIN_PATTERNS) {
    if (patterns.some((pattern) => lower.includes(pattern))) {
      return domain;
    }
  }
  return 'general';
}

/** Minimum AI/software slots in weekly digest keyword list. */
export const WEEKLY_REVIEW_MIN_AI_SOFTWARE = 3;
